import type { Profile } from "@/core/types";

export const isCompleteScreeningTaskShown = (profile: Profile): boolean => {
  const { tasks } = profile;
  const screeningTask = tasks?.find((element) => element.task_type === "A5_ASSESSMENT");

  return screeningTask !== undefined && profile.status !== "INACTIVE";
};

export const isChangePasswordTaskShown = (profile: Profile): boolean => {
  const { tasks } = profile;
  const task = tasks?.find((element) => element.task_type === "CHANGE_PASSWORD");

  return task !== undefined;
};

export const isSNSETaskShown = (profile: Profile): boolean => {
  const { tasks } = profile;
  const task = tasks?.find((element) => element.task_type === "COMPLETE_SNSE_ASSESSMENT");

  return task !== undefined;
};
